<template>
    <div>
        <div class="header mt-md-1">
            <div class="header-body">
                <div class="row align-items-center">
                    <div class="col">
                        <h6 class="header-pretitle">{{$t('Appointments')}}</h6>
                        <h1 class="header-title">{{$t('List')}}</h1>
                    </div>
                    <div class="col-auto">
                        <button @click="newAppointment" class="btn btn-info">{{$t('New appointment')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Card -->
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <!--helper move elements to left-->
                            <div class="col"></div>

                            <!--date filter-->
                            <div class="d-none d-xl-block col-auto">
                                <date-filter :label="$t('Date of visit')" v-model="dateFilter" future :initial="'today'"></date-filter>
                            </div>
                            <div class="d-none d-xl-block col-auto">
                                <date-filter v-model="createdDateFilter" :label="$t('Created at')"></date-filter>
                            </div>

                            <!--status filter-->
                            <div class="d-none d-xl-block col-auto">
                                <div class="dropdown">
                                    <b-button-group>
                                        <button
                                            class="btn btn-white"
                                            @click="statusQuery=[]"
                                            v-if="statusQuery.length>0"
                                        >
                                            <span class="fe fe-x"></span>
                                        </button>
                                        <b-dropdown variant="white" right :text="$t('Status')">
                                            <div
                                                v-for="(status, index ) in statusList"
                                                :key="index"
                                                class="dropdown-item pl-3"
                                            >
                                                <b-form-checkbox v-model="statusQuery" :value="index">
                                                    <b-badge pill :variant="status.variant">
                                                        <i class="fe" :class="status.icon"></i>
                                                    </b-badge>
                                                    {{$t(status.label) }}
                                                </b-form-checkbox>
                                            </div>
                                        </b-dropdown>
                                    </b-button-group>
                                </div>
                            </div>

                            <!-- team filter -->
                            <div class="d-none d-xl-block col-auto">
                                <team-filter v-model="staffQuery"></team-filter>
                            </div>

                            <!-- filter button -->
                            <div class="col-auto d-xl-none">
                                <b-button @click="openModal({id:'listFilterModal'})" variant="white" size="md">
                                    <i class="fe fe-filter"></i>
                                </b-button>
                            </div>

                        </div>
                    </div>

                    <div class="card-body" v-if="!areDataLoading && appointments.length==0">
                        <div class="row">
                            <div class="col-12 text-center">{{$t('Nothing yet')}}</div>
                        </div>
                    </div>
                    <div class="card-body" v-if="areDataLoading">
                        <div class="row align-items-center active">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">{{$t('Loading...')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-else>
                        <ul class="list-group list-group-lg list-group-flush list my-n4">
                            <li
                                class="list-group-item px-0 pointer"
                                v-for="(appointment, index) in appointments"
                                :key="index"
                                @click="openModal({id:'AppointmentViewModal', model:appointment})"
                            >
                                <div class="row align-items-lg-top">
                                    <!-- start date -->
                                    <div class="col-lg-2 col-12 m-2">
                                        <div class="h3 mb-0">{{ appointment.startAt | moment('LT') }}</div>
                                        <span
                                            class="small text-muted"
                                        >{{ appointment.startAt | moment('dddd, MMMM Do YYYY') }}</span>
                                    </div>
                                    <!-- avatar and creadentials -->
                                    <div class="col-lg-3 col-12 m-2" v-if="appointment.customer">
                                        <div class="row">
                                            <div class="col-auto">
                                                <avatar
                                                    type="circle"
                                                    v-if="appointment.customer.avatar"
                                                    :src="appointment.customer.avatar.preview"
                                                    size="avatar-xs"
                                                ></avatar>
                                            </div>
                                            <div col class="ml-n2">
                                                <h4 class="mb-0">
                                                    {{appointment.customer.first_name }}
                                                    {{appointment.customer.last_name}}
                                                </h4>
                                                <span class="text-muted small">{{ appointment.customer.phone }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- service start time and name -->
                                    <div class="col-lg col m-2">
                                        <div
                                            v-for="(service, serviceIndex) in appointment.services"
                                            :key="serviceIndex"
                                        >
                                            <div class="row mb-2">
                                                <div class="col-auto card-text small">
                                                    <avatar
                                                        type="circle"
                                                        :title="service.user.firstName"
                                                        v-if="service.user"
                                                        :src="service.user.avatar.preview"
                                                        size="avatar-xs"
                                                    ></avatar>
                                                </div>
                                                <div col class="ml-n2" v-if="service.treatment">
                                                    <h4 class="mb-0">{{ service.treatment.label}}</h4>
                                                    <span
                                                        class="text-muted small"
                                                    >{{ service.startAt | moment('H:mm')}} - {{service.duration}} {{$t('min')}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- appintment action buttons -->
                                    <div class="col-lg-auto m-2" v-if="1>2">
                                        <button
                                            class="btn btn-white ml-2"
                                            v-if="appointment.status != 'completed'"
                                            @click="openModal({id:'AppointmentViewModal', model:appointment})"
                                        >
                                            <i class="fe fe-eye"></i>
                                        </button>
                                        <button
                                            class="btn btn-white ml-2"
                                            v-else
                                            @click="openModal({id:'InvoiceModal', model:{invoiceId:appointment.invoiceId}})"
                                        >
                                            <i class="fe fe-eye"></i>
                                        </button>
                                    </div>
                                    <div class="col-auto m-2">
                                        <span>{{$moment(appointment.createdAt).format('DD.MM.YYYY HH:DD')}}</span>
                                    </div>
                                    <!-- appointment notes -->
                                    <div class="col-lg-auto col-auto text-muted small m-2">
                                        <status-badge iconOnly="true" :status="appointment.status"></status-badge>
                                        <div class="row mt-3">
                                            <div class="col">
                                                <i
                                                    class="fe fe-message-circle small text-muted mr-2"
                                                    v-b-tooltip
                                                    :title="appointment.notes"
                                                    v-if="appointment.notes"
                                                ></i>
                                                <i
                                                    class="fe fe-repeat small text-muted"
                                                    v-b-tooltip
                                                    :title="'Repeats '+appointment.repeat.repeat + ' Ends after ' + appointment.repeat.duration + ' Times'"
                                                    v-if="appointment.repeat"
                                                ></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>


            <!-- left side Filters modal on Mobile-->
            <mobile-filters-modal id="listFilterModal">
                <!--date filter-->
                <div class="col-12 mb-3">
                    <date-filter v-model="dateFilter" :label="filter" future></date-filter>
                </div>
                <div class="col-12 mb-3">
                    <date-filter v-model="createdDateFilter" :label="$t('Created at')"></date-filter>
                </div>

                <!--status filter-->
                <div class="col-12 mb-3">
                    <div class="dropdown">
                        <b-button-group>
                            <button
                                class="btn btn-white"
                                @click="statusQuery=[]"
                                v-if="statusQuery.length>0"
                            >
                                <span class="fe fe-x"></span>
                            </button>
                            <b-dropdown variant="white" right :text="$t('Status')">
                                <div
                                    v-for="(status, index ) in statusList"
                                    :key="index"
                                    class="dropdown-item pl-3"
                                >
                                    <b-form-checkbox v-model="statusQuery" :value="index">
                                        <b-badge pill :variant="status.variant">
                                            <i class="fe" :class="status.icon"></i>
                                        </b-badge>
                                        {{$t(status.label) }}
                                    </b-form-checkbox>
                                </div>
                            </b-dropdown>
                        </b-button-group>
                    </div>
                </div>

                <!-- team filter -->
                <div class="col-12 mb-3">
                    <team-filter v-model="staffQuery"></team-filter>
                </div>
            </mobile-filters-modal>

            <confirmation-modal id="confirmationModal" :item="model" :confirmAction="deleteItem"></confirmation-modal>
            <appointment-view-modal id="AppointmentViewModal" :appointment="model"></appointment-view-modal>
            <customer-modal :customer="model" id="customerFormModal"></customer-modal>
        </div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Avatar from '@/components/Avatar.vue'
import DateFilter from '@/components/DateFilter.vue';
import { modalMixins } from '@/mixins/modal.js'
import CustomerModal from '@/Pages/People/CustomerModal.vue';
import AppointmentViewModal from '@/Pages/Appointments/ViewModal.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import StatusBadge from '@/components/StatusBadge.vue';
import TeamFilter from '@/components/TeamFilter';
import { statusList } from '@/filters/status.js';
import mobileFiltersModal from "@/components/mobileFiltersModal";

export default {
    props: ['id'],
    mixins: [modalMixins],

    components: {
        Avatar,
        DateFilter,
        TeamFilter,
        StatusBadge,
        CustomerModal,
        ConfirmationModal,
        AppointmentViewModal,
        mobileFiltersModal
    },
    data() {
        return {
            hideForm: false,
            query: null,
            staffQuery: [],
            statusQuery: [
                'new', 'confirmed', 'started', 'arrived', 'completed', 'notConfirmed'
            ],
            dateFilter: null,
            status: null,
            filter: 'upcoming',
            tags: ['Documents', 'Images', 'Archive'],
            tagsQuery: ['', 'Documents', 'Images', 'Archive'],
            appointmentDefaults: {
                services: [{}],
            },
            createdDateFilter: null,
            params: {
                query: {
                    $limit: 100,

                    startAt: { $gte: this.$moment().startOf('day') },
                    $sort: {
                        startAt: 1
                    },
                    status: { $in: ['new', 'confirmed', 'started', 'arrived', 'completed', 'notConfirmed'] },
                }
            }
        }
    },
    computed: {
        ...mapState('appointment', { areDataLoading: 'isFindPending' }),
        ...mapGetters('appointment', { findDataInStore: 'find' }),
        ...mapGetters('service', { findServicesInStore: 'find' }),
        ...mapGetters('treatment', { findTreatmentInStore: 'find', treatment: 'get' }),
        ...mapState('my-team', { isTeamLoading: 'isFindPending' }),
        ...mapGetters('my-team', { findTeamInStore: 'find', user: 'get' }),
        ...mapGetters('customers', { getCustomer: 'get' }),


        statusList() {
            return statusList;
        },
        services() {
            return this.findServicesInStore({ query: { $sort: { priority: 1 } } }).data;
        },
        treatments() {
            return this.findTreatmentInStore().data;
        },
        appointments() {


            let items = this.findDataInStore(this.params).data;
            items.map(item => {
                // item.customer = this.customer(item.customerId);
                item.services.map(service => {
                    service.user = this.user(service.userId);
                    service.startAt = this.$moment(service.startAt);
                    service.treatment = this.treatment(service.treatmentId);
                });
            })
            return items;
        },

        staff() {
            return this.findTeamInStore().data;
        },

        customerId() {
            return this.$parent.customer._id;
        }
    },
    created() {},
    watch: {

        status: debounce(function (newVal) {
            if (newVal) {
                this.params.query.status = newVal;
            } else {
                delete this.params.query.status;
            }
            this.fetchAppointment();
        }, 200),

        '$route.params.filter': function (newVal) {
            this.filter = newVal;
            // this.fetchAppointment();
        },
        filter: function (newVal) {
            const today = this.$moment();

            // /* Clear previous values */
            // delete this.params.query.startAt;


            if (newVal == 'today') {
                // this.params.query.startAt = { $gte: today.startOf('day'), $lte: this.$moment().endOf('day') };

                // if (newVal == 'previous') {
                //     this.params.query.startAt = { $lte: today };
                // } else if (newVal == 'upcoming') {
                //     this.params.query.startAt = { $gte: today };
                // } else if (newVal == 'today') {
                //     this.params.query.startAt = { $gte: today.startOf('day'), $lte: this.$moment().endOf('day') };

                // } else if (newVal == 'late') {
                //     this.params.query.startAt = { $gte: today.startOf('day'), $lte: this.$moment().endOf('day') };
                //     delete this.params.query.status;
                //     this.params.query.status = { $ne: 'arrived' };

            }
            // this.dateFilter = newVal;

        },
        query: debounce(function (newVal) {
            if (newVal) {
                this.params.query.$or = [
                    { notes: { $regex: newVal, $options: "i" } },
                ];
            } else {
                delete this.params.query.$or;
            }

            this.fetchAppointment();
        }, 400),

        /* Find by staf  */
        staffQuery: debounce(function (newVal) {
            if (newVal.length <= 0) {
                delete this.params.query.services;
            } else {
                this.params.query.services = { userId: { $in: newVal } };
            }
            this.fetchAppointment();
        }, 400),

        statusQuery(newVal) {

            if (newVal.length <= 0) {
                delete this.params.query.status;
            } else {
                this.params.query.status = { $in: newVal };
            }
            this.fetchAppointment();
        },

        dateFilter: debounce(function (dates) {
            this.filter = null;
            if (dates.start) {
                this.params.query.startAt = {
                    $gte: dates.start,
                    $lte: dates.end
                }
            } else {
                delete this.params.query.startAt;
            }
            this.fetchAppointment();
        }, 100),

        createdDateFilter: debounce(function (dates) {
            this.filter = null;
            if (dates.start) {
                this.params.query.createdAt = {
                    $gte: dates.start,
                    $lte: dates.end
                }
            } else {
                delete this.params.query.createdAt;
            }
            this.fetchAppointment();
        }, 100),
    },
    methods: {
        ...mapActions('appointment', ['find', 'remove']),
        ...mapActions('service', { fetchServices: 'find' }),
        ...mapActions('treatment', { fetchTreatments: 'find' }),
        ...mapActions('my-team', { fetchTeam: 'find' }),
        ...mapActions('customers', { fetchCustomerById: 'get' }),

        // customer(id) {
        //     // this.fetchCustomerById(id);
        //     // return this.getCustomer(id);
        // },

        newAppointment() {

            let appointment = {
                model: {

                },
                _id: 'temp'
            };
            const { Appointment } = this.$FeathersVuex
            new Appointment(appointment);
            this.openModal({ id: 'AppointmentFastModal' });
        },

        fetchAppointment() {
            console.log('fetch appoinemtns');

            this.find(this.params);
        },

        use(image) {
            this.$root.$emit('bv::hide::modal', this.id);
            this.action(image);
        },
        save() {
            this.errors = null;
            this.hideForm = true;
        },
        deleteItem() {
            this.remove(this.model._id).then(result => {
                this.$toasted.global.success({
                    message: this.$t('Item has been deleted')
                });
            });
        }

    },


}
</script>
